import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { data } from '../_models';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentdataSubject: BehaviorSubject<data>;
    public currentdata: Observable<data>;

    constructor(private http: HttpClient) {
        this.currentdataSubject = new BehaviorSubject<data>(JSON.parse(localStorage.getItem('currentdata')));
        this.currentdata = this.currentdataSubject.asObservable();
    }

    public get currentdataValue(): data {
        return this.currentdataSubject.value;
    }

    login(email: string, password: string) {
        return this.http.post<any>(`/datas/authenticate`, { email, password })
            .pipe(map(data => {
                // login successful if there's a jwt token in the response
                if (data && data.token) {
                    // store data details and jwt token in local storage to keep data logged in between page refreshes
                    localStorage.setItem('currentdata', JSON.stringify(data));
                    this.currentdataSubject.next(data);
                }

                return data;
            }));
    }

    logout() {
        // remove data from local storage to log data out
        localStorage.removeItem('currentdata');
        this.currentdataSubject.next(null);
    }
}